import React from 'react';
import { DialogComponent } from '../../../../../Components';
import HistoryLogTable from './HistoryLogTable';

const HistoryLogDialog = ({
  open,
  setOpen,
  developerContactId,
  parentTranslationPath,
}) => {
  return (
    <DialogComponent
      titleText={'history_log'}
      isOpen={open}
      onCloseClicked={() => setOpen(false)}
      parentTranslationPath={parentTranslationPath}
      dialogContent={
        <HistoryLogTable
          developerContactId={developerContactId}
          parentTranslationPath={parentTranslationPath}
        />
      }
    />
  );
};
export default HistoryLogDialog;
